module.exports = __webpack_public_path__ + "img/dead-grey-trunk-07.cf25c3d4.png";